<script>
  import { createEventDispatcher } from "svelte";

  import Button from "components/Button.svelte";
  import { authToken } from "stores.js";
  import { _ as t } from "svelte-i18n";

  export let event;
  export let registrations;

  const dispatch = createEventDispatcher();

  const handleRegister = () => {
    dispatch("register", { eventId: event._id });
  };

  const handleRegisterAnonymous = () => {
    dispatch("loginAndRegister", { eventId: event._id });
  };

  const handleUnregister = () => {
    dispatch("unregister", { eventId: event._id });
  };

  const isRegisteredToEvent = (registrations, event) => {
    return (
      registrations && registrations.find((r) => r.sanityEventId == event._id)
    );
  };
</script>

<div class="registration">
  {#if $authToken}
    {#await $registrations then result}
      {#if isRegisteredToEvent(result.data.myRegistrations, event)}
        <p>{$t("event.registered")}</p>
        <Button on:click={handleUnregister}>{$t("event.unregister")}</Button>
      {:else}
        <p>{$t("event.notRegistered")}</p>
        <Button on:click={handleRegister}>{$t("event.register")}</Button>
      {/if}
    {/await}
  {:else}
    <Button on:click={handleRegisterAnonymous}>
      {$t("event.register")}
    </Button>
  {/if}
</div>

<style>
  .registration {
    margin: 48px 0;
    text-align: center;
  }

  .registration p {
    margin: 1rem 0;
  }
</style>
